export type GateBadge = { key: string; tool: string; owner: string; approval: string }

/**
 * One badge per declared gate, keyed by `tool:owner:index` so two gates on the same tool/owner
 * pair (or an empty owner) don't collide as `:key`s. Shared by TaskDetailView.vue (a cloned task's
 * declared gates) and CatalogView.vue (a public catalog entry's declared gates, before it is
 * cloned -- #410): both derive their badges from the same gate list this way, then format the
 * badge's displayed label/title themselves since the two views read it differently.
 */
export function buildGateBadges(
    gates: Array<{ tool: string; owner: string; approval: string }> | null | undefined,
): GateBadge[] {
    return (gates ?? []).map((gate, index) => ({
        key: `${gate.tool}:${gate.owner}:${index}`,
        tool: gate.tool,
        owner: gate.owner,
        approval: gate.approval,
    }))
}
